import React from "react";
import { isMobile } from "../helperFunc";
import HeadLines from "./HeadLines";
import Location from "./Location/Location";
import style from "./style.module.css";
const HeaderOfWidget = ({
  title,
  subtitle,
  rightText,
  onClick,
  location,
  titleClassName,
  rightTextClassName,
  subtitleClassName,
  blueLocationIcon = true,
  editIcon = true,
  showLocationFilter = true,
}) => {
  return (
    <>
      {title && (
        <HeadLines
          className={`${
            isMobile
              ? "padding-bottom4 margin-left16"
              : `font-size24 line-height28 padding-bottom8`
          } font-weight600  display-inline-block ${titleClassName}`}
          text={title}
        />
      )}
      {rightText && (
        <span
          className="display-inline-block float-right cursor-pointer"
          onClick={onClick}
        >
          <HeadLines
            className={`${style["padding-top4"]} colorAccent4 font-weight500 ${
              isMobile
                ? "font-size12 line-height14 letterSpacing025 margin-right16"
                : `font-size16 line-height19 letterSpacing05 ${
                    title === "Browse By Commodity" ? " margin-right16" : ""
                  }`
            }   ${rightTextClassName}`}
            text={rightText}
          />
        </span>
      )}
      {subtitle && (
        <HeadLines
          className={`${style["width-80"]} colorDark7 font-weight400 ${
            isMobile
              ? "font-size12 line-height14 letterSpacing025  margin-left16 "
              : "font-size20 line-height23 letterSpacing05"
          } ${
            location ? "padding-bottom4" : "padding-bottom12"
          } ${subtitleClassName}`}
          text={subtitle}
        />
      )}
      {location && (
        <div className="margin-left16 padding-bottom8">
          <Location
            blueLocationIcon={blueLocationIcon}
            editIcon={editIcon}
            showLocationFilter={showLocationFilter}
          />
        </div>
      )}
    </>
  );
};
export default HeaderOfWidget;
